export enum Actions {
  LOGIN_ERROR = "LOGIN_ERROR",
  LOGIN_STARTED = "LOGIN_STARTED",
  LOGIN_SUCCESS = "LOGIN_SUCCESS",
  SET_ANALYTIC_EVENT = "SET_ANALYTIC_EVENT",
  SET_ERROR_MESSAGE = "SET_ERROR_MESSAGE",
  SET_ID_OR_USERNAME = "SET_ID_OR_USERNAME",
  SET_PASSWORD = "SET_PASSWORD",
  SET_REMEMBER_ME = "SET_REMEMBER_ME",
  SHOW_CONFIRMATION_MODAL = "SHOW_CONFIRMATION_MODAL",
  SHOW_TNC_MODAL = "SHOW_TNC_MODAL",
  SET_TNC_CONTENT = "SET_TNC_CONTENT",
  TNC_ERROR = "TNC_ERROR",
}

export type Action =
  | {
      type: typeof Actions.LOGIN_ERROR;
      payload: {
        analyticEvent: string;
        msg: string;
      };
    }
  | {
      type: typeof Actions.LOGIN_STARTED;
    }
  | {
      type: typeof Actions.LOGIN_SUCCESS;
    }
  | {
      type: typeof Actions.SET_ANALYTIC_EVENT;
      payload: string;
    }
  | {
      type: typeof Actions.SET_ERROR_MESSAGE;
      payload: string;
    }
  | {
      type: typeof Actions.SET_ID_OR_USERNAME;
      payload: string;
    }
  | {
      type: typeof Actions.SET_PASSWORD;
      payload: string;
    }
  | {
      type: typeof Actions.SET_REMEMBER_ME;
      payload: { enableRememberMe: boolean; idOrUserName?: string };
    }
  | {
      type: typeof Actions.SHOW_CONFIRMATION_MODAL;
      payload: boolean;
    }
  | {
      type: typeof Actions.SHOW_TNC_MODAL;
      payload: boolean;
    }
  | {
      type: typeof Actions.SET_TNC_CONTENT;
      payload: { content: string; version: number };
    }
  | {
      type: typeof Actions.TNC_ERROR;
      payload: {
        analyticEvent: string;
        msg: string;
      };
    };

export type State = {
  analyticEvent: string;
  enableRememberMe: boolean;
  errorMessage: string;
  idOrUserName: string;
  isLoading: boolean;
  loginSuccess: boolean;
  loginError: boolean;
  password: string;
  showConfirmationModal: boolean;
  showTnCModal: boolean;
  tncContent: string;
  tncVersion: number;
};

export const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case Actions.LOGIN_ERROR: {
      return {
        ...state,
        analyticEvent: action.payload.analyticEvent,
        enableRememberMe: false,
        errorMessage: action.payload.msg,
        idOrUserName: "",
        isLoading: false,
        loginError: true,
        password: "",
      };
    }
    case Actions.LOGIN_STARTED: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case Actions.LOGIN_SUCCESS: {
      return {
        ...state,
        errorMessage: "",
        loginSuccess: true,
      };
    }
    case Actions.SET_ANALYTIC_EVENT: {
      return {
        ...state,
        analyticEvent: action.payload,
      };
    }
    case Actions.SET_ID_OR_USERNAME: {
      return {
        ...state,
        idOrUserName: action.payload,
      };
    }
    case Actions.SET_PASSWORD: {
      return {
        ...state,
        password: action.payload,
      };
    }
    case Actions.SET_REMEMBER_ME: {
      return {
        ...state,
        enableRememberMe: action.payload.enableRememberMe,
        idOrUserName: action.payload.idOrUserName || state.idOrUserName,
      };
    }
    case Actions.SHOW_CONFIRMATION_MODAL: {
      return {
        ...state,
        showConfirmationModal: action.payload,
      };
    }
    case Actions.SHOW_TNC_MODAL: {
      return {
        ...state,
        showTnCModal: action.payload,
        isLoading: !action.payload ? state.isLoading : false,
      };
    }
    case Actions.SET_TNC_CONTENT: {
      return {
        ...state,
        tncContent: action.payload.content,
        tncVersion: action.payload.version,
      };
    }
    case Actions.TNC_ERROR: {
      return {
        ...state,
        analyticEvent: action.payload.analyticEvent,
        errorMessage: action.payload.msg,
        isLoading: false,
        loginError: true,
        loginSuccess: false,
        showTnCModal: false,
        tncContent: "",
        tncVersion: 0,
      };
    }
    default: {
      return state;
    }
  }
};

export const initialState: State = {
  analyticEvent: "",
  enableRememberMe: false,
  errorMessage: "",
  idOrUserName: "",
  isLoading: false,
  loginSuccess: false,
  loginError: false,
  password: "",
  showConfirmationModal: false,
  showTnCModal: false,
  tncContent: "",
  tncVersion: 0,
};
